// Copyright (c) Bentley Systems
import * as React from "react";
import { Button, ProgressRadial } from "@itwin/itwinui-react";
import { SvgDelete, SvgDownload } from "@itwin/itwinui-icons-react";

export enum ButtonState {
  Primary = "Primary",
  Loading = "Loading",
}

export enum ButtonType {
  Delete = "Delete",
  Download = "Download",
}

type ButtonProps = {
  readonly buttonState: ButtonState;
  readonly onClick: () => void;
  readonly buttonType: ButtonType;
};

export const ArchiveActionButton: React.FC<ButtonProps> = ({
  buttonState,
  buttonType,
  onClick,
}) => {
  const isLoading = buttonState === ButtonState.Loading;
  const getImageBasedOnType =
    buttonType === ButtonType.Delete ? <SvgDelete /> : <SvgDownload />;
  return (
    <div>
      <Button onClick={onClick} styleType="borderless">
        {isLoading && <ProgressRadial size="x-small" indeterminate />}
        {!isLoading && getImageBasedOnType}
      </Button>
    </div>
  );
};
